import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UiIconModule } from '@cigna/ui/icon';

import { AlertComponent } from './alert.component';
import { UiButtonModule } from '@cigna/ui/button';

@NgModule({
  imports: [CommonModule, UiIconModule, UiButtonModule],
  declarations: [AlertComponent],
  exports: [AlertComponent],
})
export class UiAlertModule {}
